import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Menu, X } from 'lucide-react';
import { MessageSquare } from "lucide-react";

import './Header.css';

const MenuItem = styled.a`
  text-decoration: none;
  color: white;
  font-size: 60px;
  font-weight: 700;
  width: max-content;
  margin-bottom: 20px;

  @media (min-width: 1600px) {
    font-size: 64px;
  }

  @media (min-width: 1600px) and (min-height: 1201px) {
    font-size: 68px;
  }

  @media (min-width: 1600px) and (min-height: 1401px) {
    font-size: 72px
  }

  @media (min-width: 1600px) and (min-height: 1601px) {
    font-size: 72px
  }

  @media (max-width: 768px) {
    font-size: 44px;
    font-weight: 400;
  }
`

function Header() {
  const [scroll, setScroll] = useState(false);
  const [y, setY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const language = localStorage.getItem('language');
  const [chatHistory, setChatHistory] = useState({});


  useEffect(() => {
    const updateChatHistory = () => {
      const saved = localStorage.getItem("chatHistory");
      if (saved) {
        setChatHistory(JSON.parse(saved));
      }
    };
    updateChatHistory();
    window.addEventListener("chatHistoryUpdated", updateChatHistory);

    return () => {
      window.removeEventListener("chatHistoryUpdated", updateChatHistory);
    };
  }, []);

  // Hàm rút gọn nội dung chat nếu > 10 ký tự
  const truncateMessage = (msg) => {
    if (!msg) return '';
    return msg.length > 10 ? msg.substring(0, 10) + '...' : msg;
  };

  window.onscroll = () => {
    const el = document.scrollingElement || document.documentElement;
    const top = el.scrollTop;
    const header = document.getElementById('header');

    if (top > 50 && !scroll) {
      setScroll(true);
      header.classList.add('scroll');
    }
    else if (top <= 50 && scroll) {
      setScroll(false);
      header.classList.remove('scroll');
    }

    if (!header.classList.contains("show")) {
      if (top > 100 && y < top) {
        header.style.top = '-100px';
      }
      else {
        header.style.top = '0px';
      }
    }

    setY(top);
  }

  const HandleOpenMenu = () => {
    document.querySelector('#header').classList.add('show');
    document.body.classList.add('menu-open');
    setIsMenuOpen(true);
  }

  const HandleCloseMenu = () => {
    document.querySelector('#header').classList.remove('show');
    document.body.classList.remove('menu-open');
    setIsMenuOpen(false);
  }

  return (
    <div
      id='header'
      className='header-layer component-layout'
    >
      <div className='header-wrapper component-wrapper'>
        <div
          className='menu-layer'
        >
          <div className="sub-menu-layer">
            {language === '1' ?
              // render for english language
              <div className='menu-box'>
                <MenuItem
                  href='/'
                  onClick={HandleCloseMenu}
                >
                  Home
                  <div className='menu-item-underline' />
                </MenuItem>
                <MenuItem
                  href='https://info.pippip.vn/'
                  target='_blank'
                  rel="noreferrer"
                >
                  About Us
                  <div className='menu-item-underline' />
                </MenuItem>
                <MenuItem
                  href='/checkdonhang'
                  onClick={HandleCloseMenu}
                >
                  Check Order
                  <div className='menu-item-underline' />
                </MenuItem>

              </div>
              :
              // Render for Vietnamse language
              <div className='menu-box'>
                <MenuItem
                  href='/about'
                  onClick={HandleCloseMenu}
                >
                  Giới thiệu Pippip
                  <div className='menu-item-underline' />
                </MenuItem>
                <MenuItem
                  href='/kiemtradonhang'
                  onClick={HandleCloseMenu}
                >
                  Kiểm tra đơn hàng
                  <div className='menu-item-underline' />
                </MenuItem>
                <MenuItem
                  href='/chat/new'
                  onClick={HandleCloseMenu}
                >
                  Đặt xe Pippip
                  <div className='menu-item-underline' />
                </MenuItem>
                {Object.values(chatHistory).map(chat => (
                  <MenuItem
                    key={chat.groupId}
                    href={`/chat/${chat.groupId}`}
                    onClick={HandleCloseMenu}
                  >
                    <div className='menu-item-chat-history'>
                      {chat.lastMessage.length > 10
                        ?

                        <>
                          <MessageSquare size={20} className='menu-item-chat-icon' />
                          <span className='menu-item-chat-history-text'>{chat.lastMessage.substring(0, 20) + '...'}</span>
                        </>
                        : <>
                          <MessageSquare size={20} className='menu-item-chat-icon' />
                          <span className='menu-item-chat-history-text'>{chat.lastMessage}</span>
                        </>
                      }

                      <div className='menu-item-underline' />
                    </div>

                  </MenuItem>
                ))}
              </div>
            }
            {/* <div onClick={HandleCloseMenu} className='button-X'></div> */}
          </div>
        </div>
        <div
          id='menu-toggle'
          className='button-menu menu-toggle-button'
          onClick={isMenuOpen ? HandleCloseMenu : HandleOpenMenu}
        >
          <Menu
            size={24}
            className={`menu-icon ${isMenuOpen ? 'hidden' : 'visible'}`}
          />
          <X
            size={24}
            className={`close-icon ${isMenuOpen ? 'visible' : 'hidden'}`}
          />
        </div>
        <a href='/'>
          <img
            className='menu-logo'
            src='/Image/logo-pippip.png'
            alt=''
            style={{ borderRadius: '8px' }}
          />
        </a>
      </div>
    </div>
  );
}

export default Header;